import { DragDropData } from './drag-drop-data';
import { isUndefined, isNullOrUndefined } from './utils';

export enum GroupFieldMode {
    FIRST_NON_EMPTY = 'FIRST_NON_EMPTY',
    CONCATENATE = 'CONCATENATE',
    DUPLICATE_VALUES = 'DUPLICATE_VALUES'
}

export class GroupFieldDefinition {
    mode: GroupFieldMode;
    defaultValue: string;
    delimiter = ';';
    propagateToChildren: boolean;
    fields: Array<string>;

    constructor(value?: Partial<GroupFieldDefinition>) {
        if (value) {
            Object.assign(this, value);
        }
    }
}

export class GroupField extends DragDropData {
    fields: Array<DragDropData>;
    groupFieldDefinition: GroupFieldDefinition;
    externalName: string;

    constructor(value?: Partial<DragDropData>) {
        super(value);
    }
}

export class GroupFieldDefinitionViewModel {
    model: Partial<GroupFieldDefinition>;
    original: Partial<GroupFieldDefinition>;
    constructor(value?: Partial<GroupFieldDefinition>) {
        if (value) {
            this.model = new GroupFieldDefinition(value);
        }

        if (this.model) {
            this.original = new GroupFieldDefinition(value);
        }
    }

    dirty(): boolean {

        if (this.model.mode !== this.original.mode) {
            return true;
        }

        if (isUndefined(this.model.defaultValue)) {
            this.model.defaultValue = null;
        }

        if (!isNullOrUndefined(this.original.defaultValue)) {
            this.original.defaultValue = this.original.defaultValue.trim();
        }

        if (this.model.defaultValue !== this.original.defaultValue) {
            return true;
        }

        if (!isNullOrUndefined(this.original.delimiter)) {
            this.original.delimiter = this.original.delimiter.trim();
        }

        if (this.model.delimiter !== this.original.delimiter) {
            return true;
        }

        if (this.model.propagateToChildren !== this.original.propagateToChildren) {
            return true;
        }

        let bDirty = false;
        if (this.model.fields) {
            if (this.original.fields) {
                if (this.model.fields.length !== this.original.fields.length) {
                    return true;
                } else {
                    for (let index = 0; index < this.original.fields.length; index++) {
                        // the transformed field already existed, determine if any of the fields belonging to the transformed field have been moved (up or down) or removed entirely.
                        const currentIndex = this.model.fields.findIndex(f => f === this.original.fields[index]);
                        if (currentIndex !== index) {
                            bDirty = true;
                            break;
                        }
                    }
                }
            }
        }

        return bDirty;
    }
}
